module.exports = __webpack_public_path__ + "1.4.15-unryo/img/online-report-3.a6453bed.svg";